export class AppSettings {
    primaryColor = "#f8f9fa";
    secondaryColor = "#A16146";
    errorColor = "#f44336";
    successColor = "#618F3E";
}